// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/panel/style.scss
// module id = 444
// module chunks = 0 1